import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from 'ha/services/apiV2/types/User';

interface AvatarURLPayload {
  avatarUrl: string;
}

export default (makeCall: MakeCall) => (data: AvatarURLPayload) =>
  makeCall<User>('POST', `/api/v2/user/me/avatar-url`, {
    data,
  });
